(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bcc-google-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
 const button = event.target.closest('[data-bcc-review-direction]');
 if (!button) return;
 const track = button.closest('.bcc-reviews').querySelector('.bcc-reviews__cards');
 const card = track.querySelector('.bcc-reviews__card');
 const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
 track.scrollBy({left: Number(button.dataset.bccReviewDirection) * step, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bcc-store-info"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bcc-store-info')) {
  customElements.define('bcc-store-info', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.updateStatus = () => {
        const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
        const get = type => parts.find(part => part.type === type).value;
        const minute = Number(get('hour')) * 60 + Number(get('minute'));
        const close = ['Sat', 'Sun'].includes(get('weekday')) ? 19 : 18;
        const open = minute >= 660 && minute < close * 60;
        const label = open ? this.dataset.open + ' · ' + this.dataset.until + ' ' + (close - 12) + ' PM' : this.dataset.closed + ' · ' + (minute < 660 ? this.dataset.today : this.dataset.tomorrow) + ' 11 AM';
        this.dataset.isOpen = String(open);
        this.querySelectorAll('[data-bcc-status]').forEach(el => { el.textContent = label; });
      };
      this.onOutside = event => { if (!this.contains(event.target)) this.details.open = false; };
      this.onKey = event => { if (event.key === 'Escape' && this.details.open) { this.details.open = false; this.querySelector('summary').focus(); } };
      this.updateStatus();
      this.timer = setInterval(this.updateStatus, 30000);
      document.addEventListener('click', this.onOutside);
      document.addEventListener('keydown', this.onKey);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('click', this.onOutside);
      document.removeEventListener('keydown', this.onKey);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bcc-welcome-offer"]) return;
  try {
    
  (() => {
    function initializeOffer() {
      const dialog = document.querySelector('[data-bcc-offer]');
      if (!dialog || dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
      dialog.dataset.ready = 'true';
      const success = !!dialog.querySelector('[data-offer-success]');
      const error = !!dialog.querySelector('[data-offer-error]');
      const previewRequested = new URLSearchParams(window.location.search).get('welcome_offer') === '1';
      let seen = false;
      let claimed = false;
      try {
        seen = sessionStorage.getItem('bcc-welcome50-seen') === '1';
        claimed = localStorage.getItem('bcc-welcome50-claimed') === '1';
      } catch (_) {}
      function markSeen() {
        try { sessionStorage.setItem('bcc-welcome50-seen', '1'); } catch (_) {}
      }
      function closeOffer() { dialog.close(); }
      dialog.querySelectorAll('[data-offer-close]').forEach(button => button.addEventListener('click', closeOffer));
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeOffer();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('bcc-offer-open');
        markSeen();
      });
      if (success) {
        try { localStorage.setItem('bcc-welcome50-claimed', '1'); } catch (_) {}
      }
      if (success || error || previewRequested || (!seen && !claimed)) {
        dialog.showModal();
        document.documentElement.classList.add('bcc-offer-open');
        dialog.querySelector('#BccOfferTitle')?.focus({ preventScroll: true });
        markSeen();
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeOffer, { once: true });
    else initializeOffer();
    document.addEventListener('shopify:section:load', initializeOffer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
